import { last, ifElse, isEmpty, always } from 'ramda';

const getCompressedImageUrl = url => `${url}?q=90`;

export const getSocialImage = (url = '') => `https:${getCompressedImageUrl(url)}&fit=fill&w=1200&h=1200&f=center`;

export const getImgSrcSet = (url, sizes) =>
  sizes.map(size => `${getCompressedImageUrl(url)}&fit=pad&w=${size} ${size}w`).join(', ');

export const getImgSrcSetProps = (url, sizes = []) =>
  ifElse(
    isEmpty,
    always({ src: getCompressedImageUrl(url) }),
    always({
      src: `${getCompressedImageUrl(url)}&fit=pad&w=${last(sizes)}`,
      srcSet: getImgSrcSet(url, sizes),
    })
  )(sizes);
